import { createSlice } from "@reduxjs/toolkit";
import AUTH_API from "api/auth";
import HELPERS from "utils/helper";
import workEnvironments from "utils/workEnvironment";
import {message} from "antd";

export const targetWorkEnvironmentSlice = createSlice({
  name: "targetWorkEnvironments",
  initialState: {
    workEnvironments: [],
  },
  reducers: {
    updateWorkEnvironments: (state, action) => {
      // console.log('sss state', state, "sss payload", action)
      state.workEnvironments = action.payload;
    },
    addWorkEnvironment: (state, action) => {
      HELPERS.log("Received action addWorkEnvironment", action);
      let workEnvironments = [...state.workEnvironments];
      workEnvironments.push(action.payload);
      state.workEnvironments = workEnvironments;
    },
    updateWorkEnvironment: (state, action) => {
      HELPERS.log("Received action updateWorkEnvironment", action);
      let workEnvironments = [...state.workEnvironments];
      for (let index = 0; index < workEnvironments.length; ++index) {
        if (workEnvironments[index].id === action.payload.id) {
          HELPERS.log("Found the workEnvironment to update!");
          workEnvironments[index] = action.payload;
          break;
        }
      }
      state.workEnvironments = workEnvironments;
    },
  },
});

export const {
  updateWorkEnvironments,
  addWorkEnvironment,
  updateWorkEnvironment,
} = targetWorkEnvironmentSlice.actions;

export const fetchWorkEnvironmentsAsync = () => (dispatch) => {
  AUTH_API.getAllTargetworkenvironment().then((resp) => {
    HELPERS.log("Received response for fetchWorkEnvironmentsAsync", resp.data);
    dispatch(updateWorkEnvironments(resp.data));
  });
};

export const addWorkEnvironmentAsync = (data) => (dispatch) => {
  AUTH_API.setTargetworkenvironment(data)
    .then((response) => {
      HELPERS.log("Received response for addWorkEnvironmentAsync", response.data);
        message.success('Your work has been saved')
      dispatch(addWorkEnvironment(response.data));
    })
    .catch((err) => console.log("error", err));
};

export const deleteWorkEnvironmentAsync = (key) => (dispatch) => {
  AUTH_API.targetWorkEnvironmentsPatch({ learn_more: false }, key)
    .then((response) => {
      HELPERS.log("Received response for deleteWorkEnvironmentAsync", response.data);
        message.success('Your work has been saved')
      dispatch(updateWorkEnvironment(response.data));
    })
    .catch((err) => console.log("error", err));
};

export const updateWorkEnvironmentAsync = (key, data, Stepname) => (dispatch) => {
  AUTH_API.targetWorkEnvironmentsPatch(data, key, Stepname)
    .then((response) => {
      HELPERS.log("Received response for updateWorkEnvironmentAsync", response);
      // message.success('Your work has been saved');
      dispatch(updateWorkEnvironment(response.data));
    })
    .catch((err) => console.log("error", err));
};

export const selectTargetWorkEnvironment = (state) =>
  state.targetWorkEnvironment.workEnvironments

export const selectTargetWorkEnvironmentsToLearnMore = (state) =>
  state.targetWorkEnvironments.workEnvironments.filter(
    (workEnvironment) => workEnvironment.learn_more === true
  );

export const selectAllIndustries = (state) => {
  const allIndustries = [];
  const addedIndustries = new Set();

  for (var industry of state.targetWorkEnvironments.workEnvironments) {
    if (!addedIndustries.has(industry.title)) {
      addedIndustries.add(industry.title);
      allIndustries.push({
        id: industry.id,
        value: industry.title,
        selected_for: industry.selected_for,
      });
    }
  }

  for (var industry of workEnvironments) {
    if (!addedIndustries.has(industry.value)) {
      addedIndustries.add(industry.value);
      allIndustries.push({
        id: 0,
        value: industry.value,
        selected_for: [],
      });
    }
  }

  return allIndustries.sort((a, b) => {
    var res = 0;
    if (a.value < b.value) res = -1;
    else if (a.value > b.value) res = 1;
    return res;
  });
};

export const selectTargetWorkEnvironmentsCount = (state) =>
  state.targetWorkEnvironments.workEnvironments.filter(
    (industry) => industry.learn_more === true
  ).length;

export default targetWorkEnvironmentSlice.reducer;